import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AUTHZ_ROLE_QUERY_KEY } from "../config";
import { fetchAuthzRoleConfiguration, saveAuthzRoleConfiguration } from "../repo";
import type { AuthzRoleConfigurationMutation } from "../types";

/** 编排角色详情加载和统一保存。 */
export function useAuthzRoleConfigurationRuntime(roleId: number) {
  const queryClient = useQueryClient();
  const configurationQuery = useQuery({
    queryKey: [...AUTHZ_ROLE_QUERY_KEY, roleId, "configuration"],
    queryFn: () => fetchAuthzRoleConfiguration(roleId),
    enabled: Number.isInteger(roleId) && roleId > 0,
  });
  const saveMutation = useMutation({
    mutationFn: (payload: AuthzRoleConfigurationMutation) =>
      saveAuthzRoleConfiguration(roleId, payload),
    onSuccess: (configuration) => {
      queryClient.setQueryData([...AUTHZ_ROLE_QUERY_KEY, roleId, "configuration"], configuration);
      void queryClient.invalidateQueries({ queryKey: AUTHZ_ROLE_QUERY_KEY });
    },
  });
  return { configurationQuery, saveMutation };
}
